/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum WebSocketCloseCodes {
    NormalClosure = 1000,
    GoingAway = 1001,
    UnsupportedData = 1003,
    AbnormalClosure = 1006,
}
